import React from "react";
import { Link } from "react-router-dom";
export default function Copyright() {
  return (
    <>
      <div className="bds-footerbtm">
        <div className="container">
          <div className="row justify-content-between gy-3">
            <div className="col-lg-6">
              <div className="bds-footerbtmtitle">
                <h6>Copyright © All rights reserved. 2022</h6>
              </div>
            </div>
            <div className="col-lg-6">
              <ul className="bds-footetbtmlinks">
                <li>
                    <Link to="#">Terms of service </Link>
                </li>
                <li>
                    <Link to="#">Privacy policy </Link>
                </li>
                <li>
                    <Link to="#">Content privacy</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
